import React, { ReactNode } from 'react';

import { HEADER_ID } from '@/components/templates/PageLayout';
import {
  CmBox,
  CmCloseButton,
  CmFlex,
  CmScrollBox,
} from '@/components/uiParts';
import { useTargetsDomHeight } from '@/hooks/Dom';

const STORE_MANAGEMENT_SIDEBAR_WIDTH = 500;
const BUTTON_AREA_HEIGHT = 80;

type Props = {
  children: ReactNode;
  buttonComponent?: ReactNode;
  isSidebarOpen: boolean;
  handleCloseSidebar: () => void;
};

export const SidebarWrapper: React.FC<Props> = ({
  children,
  buttonComponent,
  isSidebarOpen,
  handleCloseSidebar,
}) => {
  const { targetsHeight: headerHeight } = useTargetsDomHeight([HEADER_ID]);
  const contentHeight = `calc(100vh - ${headerHeight}px)`;
  return (
    <>
      {isSidebarOpen && (
        <CmBox
          position="absolute"
          top={headerHeight}
          zIndex={2}
          right={0}
          w={STORE_MANAGEMENT_SIDEBAR_WIDTH}
          background="white"
          height={contentHeight}
          padding={`${BUTTON_AREA_HEIGHT}px 20px 40px 20px`}
        >
          <CmBox
            position="absolute"
            top={0}
            right={0}
            width="100%"
            padding="20px"
          >
            <CmFlex justifyContent={'space-between'} alignItems="center">
              <CmCloseButton size="lg" onClick={handleCloseSidebar} />
              {buttonComponent}
            </CmFlex>
          </CmBox>

          <CmScrollBox
            height={`calc(100vh - ${headerHeight + BUTTON_AREA_HEIGHT}px)`}
            pb="50px"
          >
            {children}
          </CmScrollBox>
        </CmBox>
      )}
    </>
  );
};
